import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=84d75278&scoped=true"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"
import style1 from "./Assets.vue?vue&type=style&index=1&id=84d75278&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d75278",
  null
  
)

export default component.exports